import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, Event } from '@angular/router'
import { MatDialog } from '@angular/material';
import { CurrentSlideService } from '../../_services/current-slide.service';
import { SectionsService } from '../../_services/sections.service';
import { AppConstants } from '../../app.constants';
import { openClose } from '../../_animations/animations';
import { StoryModalComponent } from '../../shared/story-modal/story-modal.component';

import { Subject } from 'rxjs';
import { takeUntil} from 'rxjs/operators';

@Component({
	selector: 'secondary-nav',
	templateUrl: './secondary-nav.component.html',
	styleUrls: ['./secondary-nav.component.scss'],
	host: {'class': 'secondary-nav'},
	animations: [openClose]
})
export class SecondaryNavComponent implements OnInit {

	private unsubscribe$ = new Subject<void>();

	sections = [];
	sectionsContent = [];
	isMenuOpen: boolean = false;
	isSubmenuOpen: boolean = false;
	isStoryPage: boolean = false;
	scrollPos: number = 0;
	public autoplay: boolean;
	public autoplayTest: boolean;
	
	constructor(private _router: Router, private _currentSlideService: CurrentSlideService, private _sectionsService: SectionsService, public dialog: MatDialog) {
		_router.events
		.pipe(takeUntil(this.unsubscribe$))
		.subscribe( (event: Event) => {
			if (event instanceof NavigationEnd) {
				let url = this._router.url.split('/');
				if(url[2] == 'story'){
					this.isStoryPage = true;
				}
				else{
					this.isStoryPage = false;
				}
			}
		});
	}

	ngOnInit() {
		var base = this;
		this.sections = ['Exploration', 'New York City', 'Pop Culture', 'Innovation'];

		let sections = [
			AppConstants.sectionExploration,
			AppConstants.sectionCity,
			AppConstants.sectionPopCulture,
			AppConstants.sectionInnovation
		]

		sections.forEach(function(value){
			let newSectionCarousel = [];
			var j = 0;
			for(var i = 0; i < value.length; i++){
				if(value[i].scrollContent){
					for(var k = 0; k < value[i].scrollContent.length; k++){
						newSectionCarousel.push(value[i].scrollContent[k])	
						newSectionCarousel[j].id = j;
						j++;
					}
					
				}
				/*if(value[i].scrollContent && value[i].scrollContent.length > 1){
					for(var k = 0; k < value[i].scrollContent.length; k++){
						newSectionCarousel.push(value[i].scrollContent[k])	
						newSectionCarousel[j].id = j;
						j++;
					}
					
				}
				else{
					newSectionCarousel.push(value[i])	
					newSectionCarousel[j].id = j;
					j++;
				}*/
			}
			base.sectionsContent.push(newSectionCarousel);
		})


		//this.sectionsContent.push(AppConstants.sectionExploration, AppConstants.sectionInnovation, AppConstants.sectionCity, AppConstants.sectionSea, AppConstants.sectionOther);
		

		

		//this.autoplay = this._currentSlideService.getAutoplay();
		this._currentSlideService.autoplay
		.pipe(takeUntil(this.unsubscribe$))
		.subscribe(data => {
			if(!this.isMenuOpen){
				this.autoplay = data;
			}
		});

	}

	toggleMenu(event){
		event.preventDefault();
		
		if(this.isMenuOpen){
			//close
			this._currentSlideService.setAutoLoopHome(true);	
			this.isMenuOpen = false;
			if(this.autoplay){
				this._currentSlideService.setAutoplay(true);	
			}
		}
		else{
			//open
			this._currentSlideService.setAutoLoopHome(false);	
			/*this._currentSlideService.autoplay
			.pipe(takeUntil(this.unsubscribe$))
			.subscribe(data => {
				this.autoplay = data;
			});*/
			this.isMenuOpen = true;
			this._currentSlideService.setAutoplay(false);
		}
	}

	toggleSubmenu(){
		this.isSubmenuOpen = !this.isSubmenuOpen;
	}

	goSection(pos){
		let windowH = $(window).height();
		let page = $('.timeline-scroll');
		let pageH = page.height();
		let el = $('.timeline-section-'+pos);
		let newPosition = el.position().top - page.position().top;
		page.stop().animate({
			scrollTop: newPosition
		}, 2000);
	}

	scrollDown(e){
		this.scrollPos = $(".timeline-scroll").scrollTop();
		$(".timeline-scroll").stop().animate({
			scrollTop: this.scrollPos + 400
		}, 800);
	}
	scrollUp(e){
		this.scrollPos = $(".timeline-scroll").scrollTop();
		$(".timeline-scroll").stop().animate({
			scrollTop: this.scrollPos - 400
		}, 800);
	}


	launchStoryModal(content){
		let url;
		let type;
		if(content.type == 'video'){
			type = 'video';
			url = content.video;
		}
		else{
			type = 'image'
			url = content.image;
		}
		let videoModal = this.dialog.open(StoryModalComponent, {
			data: { 
				type: type,
				contentUrl: url
				
			}
		});
		videoModal.afterClosed()
		.pipe(takeUntil(this.unsubscribe$))
		.subscribe(result => {
		});
	}


	/*onPanStart(evt){
		this.scrollPos = $(".timeline-scroll").scrollTop();
		this.scrollTimeline(evt.deltaY);
		$(".timeline-scroll").stop().animate({
			scrollTop: this.scrollPos
		}, 0);
	}
	onPanEnd(evt){
		this.scrollPos = $(".timeline-scroll").scrollTop();
		let newPos = this.scrollPos - (this.scrollPos * evt.velocityY/10);
		let duration = evt.velocityY * 1000;
		if(duration < 1){
			duration = -duration;
		}
		$(".timeline-scroll").stop().animate({
			scrollTop: newPos
		}, duration, "easeOutExpo");


	}
	onPan(evt){
    	this.scrollTimeline(evt.deltaY);

    }*/

    scrollTimeline(scroll){
    	let newScroll = this.scrollPos - scroll;
    	$(".timeline-scroll").scrollTop(newScroll);
    }

    onTap(){
    	this.scrollPos = $(".timeline-scroll").scrollTop();
    	$(".timeline-scroll").stop().animate({
			scrollTop: this.scrollPos
		}, 0);
    }

    ngOnDestroy(): void {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
	} 




}






